<template>
    <div class="card" :class="package">
        <div class="card-header">
            <h5 class="card-title text-center text-white" style="text-transform: capitalize;">{{ this.package }}
                Package</h5>
        </div>
        <div class="card-body d-flex flex-column">
            <table class="table mb-1">
                <tr v-for="(bill, key) in this.active" :class="{'pb-1': key === 0}" v-if="bill.visible">
                    <td class="border-top-0 text-left" width="30px">
                        <img v-bind:src="bill.icon" alt="">
                    </td>
                    <td class="border-top-0 text-left" width="180px">
                        <span>{{ bill.name }}</span> <span v-if="bill.helper" class="info-icon" data-toggle="tooltip"
                                                           data-placement="bottom" :title="bill.helper">?</span><br/>
                        <span class="provider text-black-50">
                            <span v-if="bill.bill.group.id === 4">
                                By including TV Licence, your <strong>first</strong> monthly payment will be higher
                                <span class="info-icon"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    :title="`Your first monthly payment will be £${totalPlusTVLicence}, then it will drop down to £${cost.per_person} from your 2nd month onwards. The reason your first payment is higher is because the TV Licence company charge in quarterly installments rather than monthly.`"
                                > ? </span>
                            </span>
                            <span v-else>{{ bill.bill.provider.name }}</span>
                            <span v-if="multiProviders.includes(bill.bill.group.name) && countExtrasForGroup(bill.bill.group.id)" class="change clickable"
                                  @click="providerModalToggle(bill.bill.group.id)">(change)</span>
                        </span>
                    </td>
                    <td class="border-top-0 text-right text-black-50">
                        <span class="clickable"
                              v-if="!['Water', 'Renewable Energy', 'Internet', 'TV Package', 'Heat Billing'].includes(bill.bill.group.name) || entertainment.includes(bill.name)"
                              @click="removeBill(key)">Remove</span>
                    </td>
                </tr>
            </table>

            <table class="table" v-if="this.free_perks.length > 0">
                <thead>
                <tr>
                    <td class="border-top-0 text-left">Free Perks</td>
                    <td class="border-top-0 text-right text-black-50">
                        <span @click="perk_toggled = !perk_toggled" variant="primary">
                            <font-awesome-icon icon="chevron-down" fixed-width
                                               v-bind:class="[perk_toggled ? 'rotate up' : 'rotate'] "/>
                        </span>
                    </td>
                </tr>
                </thead>
            </table>

            <b-collapse v-model="perk_toggled" class="mt-2">
                <table class="table">
                    <tr v-for="(perk, key) in this.free_perks">
                        <td class="border-top-0 text-left" width="30px">
                            <img v-bind:src="perk.icon" alt="">
                        </td>
                        <td class="border-top-0 text-left" width="160px">
                            <span>{{ perk.name }}</span> <span v-if="perk.helper" class="info-icon" data-toggle="tooltip"
                                                                data-placement="bottom" :title="perk.helper">?</span><br/>
                            <span class="provider text-black-50">{{ perk.bill.provider.name }}
                            </span>
                        </td>
                        <td class="border-top-0 text-right text-green clickable">Free</td>
                    </tr>
                </table>
            </b-collapse>

            <table class="table" v-if="this.extras && countAvailableExtras">
                <thead>
                <tr>
                    <td class="border-top-0 text-left">Optional Add-ons</td>
                    <td class="border-top-0 text-right text-black-50">
                        <span @click="toggled = !toggled" variant="primary">
                            <font-awesome-icon icon="chevron-down" fixed-width
                                               v-bind:class="[toggled ? 'rotate up' : 'rotate'] "/>
                        </span>
                    </td>
                </tr>
                </thead>
            </table>

            <b-collapse v-model="toggled" class="mt-2">
                <table class="table">
                    <tr v-for="(addon, key) in this.extras" v-if="addon.visible">
                        <td class="border-top-0 text-left" width="30px">
                            <img v-bind:src="addon.icon" alt="">
                        </td>
                        <td class="border-top-0 text-left" width="160px">
                            <span>{{ addon.name }}</span> <span v-if="addon.helper" class="info-icon" data-toggle="tooltip"
                                                                data-placement="bottom" :title="addon.helper">?</span><br/>
                            <span class="provider text-black-50">{{ addon.bill.provider.name }}
                            </span>
                        </td>
                        <td class="border-top-0 text-right text-green clickable" @click="addBill(key)">Add Bill</td>
                    </tr>
                </table>
            </b-collapse>

            <table class="table total">
                <tr>
                    <td class="text-left big">Total</td>
                    <td class="text-right big">*£{{ this.cost.per_person }}/month <br/><sup
                        class="text-black-50 ">Per bill payer</sup>
                    </td>
                </tr>

                <tr>
                    <td class="text-left"></td>
                    <td class="text-right">£{{ this.cost.house }} /month <br/><sup
                        class="text-black-50 ">Total cost for the household based on {{ this.tenants }} tenants</sup>
                    </td>
                </tr>

            </table>

            <div class="row">
                <div class="col-12">
                    <button class="btn btn-primary w-100 mt-auto" @click="confirmPackage" :disabled="processing">
                        Select This Package
                        <fa-spinner v-show="processing"/>
                    </button>
                </div>
            </div>

            <tr class="mt-4">
                <td class="text-right text-black-50" style="line-height: 1"><sup>*Includes a management fee of £{{ parseFloat(this.fee / this.billPayers).toFixed(2) }}/month per bill payer</sup></td>
            </tr>

        </div>

        <partner-bill-compare-modal
            :bills="providerModal.bills" :housemates="parseInt(this.tenants)" :show="providerModal.toggle"
            @close="providerModal.toggle = false" @switch="providerModalConfirm($event)"
        ></partner-bill-compare-modal>

    </div>
</template>

<script>
import FaSpinner from "../../FaSpinner";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import PartnerBillCompareModal from "./PartnerBillCompareModal";

export default {
    name: "PartnerPackages",

    components: {PartnerBillCompareModal, FaSpinner, FontAwesomeIcon},

    props: [
        "package",
        "bills",
        "addons",
        "tenants",
        "billPayers",
        "fee",
        "partner",
        "perks"
    ],

    data() {
        return {
            cost: {
                house: 0,
                per_person: 0
            },
            extras: [],
            active: [],
            free_perks: [],
            toggled: false,
            perk_toggled: false,
            entertainment: [
                "Entertainment + Sports",
                "Entertainment + Cinema",
                "Entertainment + Box Sets",
                "All Sky TV channels"
            ],
            providerModal: {
                bills: [],
                toggle: false
            },
            multiProviders: ['Internet', 'Renewable Energy', 'TV Package'], // Groups with multiple bill choices
            processing: false,
            tv_licence_installation_fee: 26
        };
    },

    mounted() {
        this.load();
        this.calculateDefaults();
        this.prices();
    },

    methods: {
        confirmPackage() {
            let data = {
                package: this.package,
                bills: [...this.active, ...this.free_perks]
            };

            this.processing = 1;

            axios
                .post("/partner/" + this.partner + "/onboarding/packages", data)
                .then(response => {
                    window.location.href = response.data.url;
                });
        },

        addBill(index) {
            let bill = this.extras[index];

            if (!bill.visible) {
                bill.visible = true;
            }

            this.extras.splice(index, 1);
            this.active.push(bill);
            this.tvPackage(bill, false);
            this.prices();

            $(function () {
                $('[data-toggle="tooltip"]').tooltip()
            });
        },

        removeBill(index) {
            let bill = this.active[index];

            this.active.splice(index, 1);
            this.extras.push(bill);

            this.tvPackage(bill, true);
            this.prices();
        },

        tvPackage(bill, type) {
            let bills = this.entertainment;
            if (!bills.includes(bill.name)) {
                return;
            }
            _.forEach(this.active, (value, key) => {
                if (value.name === "Entertainment") this.active[key].visible = type;
            });
            _.forEach(this.extras, (value, key) => {
                if (bills.includes(value.name)) this.extras[key].visible = type;
            });
        },

        countExtrasForGroup(group_id) {
            return _.filter(this.extras, {'bill': {'group_id': group_id}}).length
        },

        providerModalToggle(group_id) {
            // Get all bills and addons from the active group
            this.providerModal.bills = _.filter(_.concat(this.active, this.extras), {'bill': {'group_id': group_id}});
            this.providerModal.toggle = true;
        },

        providerModalConfirm(bill_id) {

            // Reset and close modal
            this.providerModal = {
                toggle: false,
                bills: []
            };

            let index = _.findIndex(this.extras, ['id', bill_id]);

            if (index !== -1) {

                let replacement = this.extras[index];
                let group = replacement.bill.group_id;

                // Remove any active bills belongs to the replacement's group
                for (let i = 0; i < this.active.length; i++) {
                    let item = this.active[i];
                    if (item.bill.group_id === group) {
                        item.visible = false;
                        this.removeBill(i);
                        i++; // Removed bill, so list is shorter
                    }
                }

                // Add replacement to active group
                this.addBill(index);
            }

            this.prices();
        },

        prices() {
            let total = 0;
            let perTenant = 0;
            let subTotal = 0;
            let tenants = parseInt(this.tenants);
            let fee = parseFloat(this.fee);

            _.forEach(this.active, value => {
                perTenant += parseFloat(value.price);
            });

            subTotal = perTenant * tenants;
            total = subTotal + fee;

            this.cost.house = _.round(total, 2);
            this.cost.per_person = _.round(this.cost.house / this.billPayers, 2);
        },

        load() {
            let active = [];
            let extra = [];
            let free_perks = [];
            let bills = JSON.parse(this.bills);
            let addons = JSON.parse(this.addons);
            let perks = JSON.parse(this.perks);

            _.forEach(bills, value => active.push(value));
            _.forEach(addons, value => extra.push(value));
            _.forEach(perks, value => free_perks.push(value));

            this.active = active;
            this.extras = extra;
            this.free_perks = free_perks;
        },

        calculateDefaults() {
            let i = this.extras.length;
            let extras = this.extras;
            while (i--) {
                let addBill = false;
                let chosen = extras[i];
                if (["Council Tax"].includes(chosen.name)) {
                    addBill = true;
                }

                if (
                    ["All Sky TV channels", "Virgin VOOM"].includes(chosen.name) &&
                    this.package === "platinum"
                ) {
                    addBill = true;
                }

                if (
                    ["All Sky TV channels", "Cleaner", "Virgin VOOM"].includes(
                        chosen.name
                    ) &&
                    this.package === "diamond"
                ) {
                    addBill = true;
                }

                if (addBill) {
                    this.addBill(i);
                }
            }
        }
    },

    computed: {
        countAvailableExtras() {
            return _.filter(this.extras, {visible: true}).length;
        },
        totalPlusTVLicence() {
            const house = (this.cost.house + this.tv_licence_installation_fee) / this.billPayers
            return house.toFixed(2)
        }
    }
};
</script>

<style scoped>
.card {
    min-height: 760px;
}

.card span.provider {
    font-size: 12px;
}

.clickable {
    cursor: pointer;
}

.card span.change {
    text-decoration: underline;
}

.card .text-green {
    color: #5dbc3f;
}

.rotate {
    -moz-transition: all 0.35s linear;
    -webkit-transition: all 0.35s linear;
    transition: all 0.35s linear;
}

.rotate.up {
    -ms-transform: rotate(180deg);
    -moz-transform: rotate(180deg);
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
}
</style>
